import React, {  useRef } from "react";
import { Form, Input,  Modal,  Spin } from "antd";
import {  useDispatch, useSelector } from "react-redux"; 
import toast from "react-hot-toast";
import { save } from "../../../features/save/saveSlice";

const IrrigationPartnerAddModal = ({ isModalOpen, handleCancel, handleFetch,prodd }) => {
  const dispatch =  useDispatch()
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
 
  const onFinish = async (data) => { 
    data.ipcId = prodd?.ipcId ? prodd?.ipcId : null; 
    data.ipcLink = '/irrigation-partner-view'
    data.ipcSvg = 'svg38'
    const res = await dispatch(
      save({
        ...data,
        url: "api/v2/irr_part_cat/save",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await handleFetch()
      await form.resetFields();
      await handleCancel();
    } else {
      toast.error(res?.payload?.message);
    }
  };
  return (
    <>
      <Modal
        className="!w-[39.875rem]"
        title={"Add a New Irrigation Partner Group"}
        open={isModalOpen}
        onOk={onFinish}
        onCancel={handleCancel} 
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=""
          style={{
            maxWidth: "100%",
          }}
          form={form}
        > 

          <Form.Item
            name="ipcName"
            label="Insititution Type"
            rules={[
              {
                required: true,
                message: "Please add Insititution Type",
              },
            ]}
          >
            <Input placeholder="insititution type" className="input" />
          </Form.Item>

          
          <div className="flex justify-between mt-[1.75rem] ">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center  gap-x-5">
              <div className="w-[100px] ">
                <button
                  type="button"
                  key="back"
                  onClick={handleCancel}
                  className="cstm-btn"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[100px]">
                <button disabled={saving} key="submit" type="submit" className="cstm-btn-2">
                  {saving ? <Spin /> : "Save"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default IrrigationPartnerAddModal;
